var map = {
	"./class-attendance-report/route.js": "fdc2",
	"./class-attendance-v2/route.js": "7cd9",
	"./monthly-semester-mapping/router.js": "2f7a",
	"./router.js": "37f3",
	"./score-copy/router.js": "b472",
	"./student-transfer/components/index.js": "c71c",
	"./student-transfer/router.js": "e2a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52f3";